import { PropsWithChildren } from 'react';
import Typography from '@mui/material/Typography';

type SttLabelTitleProps = PropsWithChildren<{
    style?: React.CSSProperties;
}>;

export function SttLabelTitle({ style, children }: SttLabelTitleProps) {
    return <Typography sx={style}>{children}</Typography>;
}
